var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prospectlist-comment"},[_c('h4',[_vm._v("Comments")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"card-text show-white-space"},[_vm._v(_vm._s(_vm.comments))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }